export const CHEMICAL_DB_API_HOST = import.meta.env.VITE_CHEMICAL_DB_API_BASE_URL;

export const CHEMICALS_SEARCH_API = '/api/chemicals/search';

export const DEFAULT_PAGE_SIZE = 50;

export const JSON_HEADERS = { 'Content-Type': 'application/json' };
